import { render, staticRenderFns } from "./WorkFilesUnit.vue?vue&type=template&id=32635c84&scoped=true"
import script from "./WorkFilesUnit.vue?vue&type=script&lang=js"
export * from "./WorkFilesUnit.vue?vue&type=script&lang=js"
import style0 from "./WorkFilesUnit.vue?vue&type=style&index=0&id=32635c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32635c84",
  null
  
)

export default component.exports